/* Green Life speed fixes (SPEED TEST 13 Oct 2026). Loaded with defer right after bundle-head.js.
   1) Smooth scrollbars (mini cart, popups) ran an endless 60 fps loop even when idle. Pause the loop while
      nothing is moving and wake it the moment a wheel or touch adds momentum.
*/
(function () {
  try {
    var SB = window.Scrollbar;
    if (SB && SB.init && !SB.__glPatched) {
      SB.__glPatched = true;
      var patchProto = function (inst) {
        var P = inst && Object.getPrototypeOf(inst);
        if (!P || P.__glIdle || typeof P._render !== 'function' || typeof P.setMomentum !== 'function') return;
        P.__glIdle = true;
        var render = P._render, setM = P.setMomentum;
        P._render = function () {
          var m = this._momentum;
          if (m && !m.x && !m.y) { this.__glSleeping = true; this._renderID = 0; return; }
          this.__glSleeping = false;
          return render.apply(this, arguments);
        };
        P.setMomentum = function () {
          var r = setM.apply(this, arguments);
          if (this.__glSleeping) { this.__glSleeping = false; render.call(this); }
          return r;
        };
      };
      var init = SB.init;
      SB.init = function () { var s = init.apply(this, arguments); patchProto(s); return s; };
      if (SB.getAll) SB.getAll().forEach(function (s) { patchProto(s); });
    }
  } catch (e) {}
})();
